import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';

export function usePlatformAdmin() {
  const query = useQuery({
    queryKey: ['platform-admin'],
    queryFn: () => apiFetch<{ data: { is_platform_admin: boolean } }>('/api/me/platform-admin'),
    staleTime: 5 * 60_000,
  });
  return { isAdmin: query.data?.data.is_platform_admin ?? false, isLoading: query.isLoading };
}
